import { rfqConfirmationProductListStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationProductList";
import { css } from "styled-components";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";

Object.assign(rfqConfirmationProductListStyles, {
    ...rfqConfirmationProductListStyles,
    cartLinesList: {
        cardExpanded: {
            productDescriptionAndPartNumbersGridItem: { width: [12, 12, 7, 7, 7] },
            productPriceAndQuantityGridItem: { width: [12, 12, 5, 5, 5] },
            // priceGridItem: { width: 9 },
            priceGridItem: {
                width: 7,
                css: css`
                    span[data-test-selector^="productPrice_unitNetPrice"] {
                        color: rgb(30, 117, 186);
                    }
                `,
            },
            quantityGridItem: {
                width: 5,
                css: css`
                    & div {
                        margin-top: 0px;
                        flex-direction: row;
                        align-items: center;
                        border-radius: 8px;
                        background-color: #e1e7ed;
                        color: ${COLORS.lightBlack};
                        p {
                            text-align: center;
                            padding: 8px;
                            width: 100%;
                            justify-content: center;
                            margin-bottom: 0 !important;
                            font-size: 14px;
                        }
                    }
                `,
            },
            extendedUnitNetPriceGridItem: { width: 0 },
        },
    },
    backToTopButton: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            margin-top: 1rem;
            text-transform: uppercase;
            border-radius: 22px;
            border: 1px solid ${COLORS.secondaryBtn};
            min-width: 120px;
            background: ${COLORS.white};
            color: ${COLORS.secondaryBtn};
            & :hover {
                background: ${COLORS.secondaryBg};
                border: 1px solid ${COLORS.secondaryBtn};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
                border: 1px solid ${COLORS.disabled.base};
            }
        `,
    },
});
